import { useRef, useState } from 'react'

export default function ConfirmModal({ open, title, message, onConfirm, onCancel }) {
  const overlayRef = useRef()
  if (!open) return null

  return (
    <div ref={overlayRef} className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={(e) => e.target === overlayRef.current && onCancel()}>
      <div className="w-full max-w-sm rounded-xl border border-orken-border bg-orken-bg-card p-6 shadow-xl">
        <h3 className="text-base font-bold text-white">{title}</h3>
        <p className="mt-2 text-sm text-orken-dim">{message}</p>
        <div className="mt-5 flex items-center justify-end gap-3">
          <button onClick={onCancel} className="rounded-lg border border-orken-border px-4 py-2 text-sm font-medium text-orken-dim hover:bg-white/5 hover:text-white transition-colors">
            Cancelar
          </button>
          <button onClick={onConfirm} className="rounded-lg bg-red-600 px-4 py-2 text-sm font-bold text-white hover:bg-red-700 transition-colors">
            Excluir
          </button>
        </div>
      </div>
    </div>
  )
}
